









































import {
  defineComponent,
  PropType,
  ref,
  inject,
  onMounted,
  computed
} from '@nuxtjs/composition-api';
import FilterBox from 'components/catalog/Category/Filters/Renderer/FilterBox.vue';
import type { Aggregation } from '@wemade-vsf/magento-api';

export default defineComponent({
  props: {
    filter: {
      type: Object as PropType<Aggregation>,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  components: {
    FilterBox
  },
  setup (props, { emit }) {
    const { selectedFilters } = inject('UseFiltersProvider');
    const slider = ref(null);
    const timeout = ref(null);
    const taxRate = props.filter.frontend_input === 'price' ? 25 : 0;

    const values = computed<number[]>(() => {
      if (props.filter.options?.length) {
        return props.filter.options.map(opt => {
          const value = parseFloat(opt?.value ? String(opt.value) : '0')
          return Math.round(value + (value * taxRate / 100))
        })
      }
      return [0]
    })
    const min = computed(() => values.value ? Math.min(...values.value) : 0)
    const max = computed(() => values.value ? Math.max(...values.value) : 0)

    function getPercent(value) {
      return ((value - min.value) / (max.value - min.value)) * 100;
    }

    const updateCssVars = (minVal, maxVal) => {
      const leftPercent = getPercent(minVal);
      const highLightWidth = getPercent(Math.abs(maxVal - minVal));
      slider.value.style.setProperty("--highlightWidth", `${highLightWidth}%`);
      slider.value.style.setProperty("--leftPercent", `${leftPercent}%`);
    }

    const updateValues = (minVal, maxVal) => {
      updateCssVars(minVal, maxVal);
      if (timeout.value) {
        clearTimeout(timeout.value);
      }
      minVal = Math.round(minVal / (taxRate + 100) * 100)
      maxVal = Math.round(maxVal / (taxRate + 100) * 100)
      timeout.value = setTimeout(() => {
        emit('selectFilter', { value: `${minVal}_${maxVal}` })
      }, 1500);
    }

    const minAngle = ref(min.value)
    const maxAngle = ref(max.value)

    const minValue = computed({
      get: () => minAngle.value,
      set: (val) => {
        if (val > maxAngle.value) {
          maxAngle.value = val
        }
        minAngle.value = val
        updateValues(minAngle.value, maxAngle.value)
      }
    })

    const maxValue = computed({
      get: () => maxAngle.value,
      set: (val) => {
        if (val < minAngle.value) {
          minAngle.value = val
        }
        maxAngle.value = val;
        updateValues(minAngle.value, maxAngle.value)
      }
    })

    onMounted(() => {
      const filterValue = selectedFilters.value?.[props.filter.attribute_code]?.[0];
      if (filterValue) {
        let [minSelect, maxSelect] = filterValue.split("_");
        if (minSelect && maxSelect) {
          minSelect = parseFloat(minSelect);
          maxSelect = parseFloat(maxSelect);
          if (!isNaN(minSelect) && !isNaN(maxSelect)) {
            minAngle.value = Math.round(minSelect * (taxRate + 100) / 100);
            maxAngle.value = Math.round(maxSelect * (taxRate + 100) / 100);
            updateCssVars(minAngle.value, maxAngle.value);
          }
        }
      }
    })
    
    return {
      min,
      max,
      minValue,
      maxValue,
      slider,
      selectedFilters
    }
  }
})
